import { render, staticRenderFns } from "./JournalEntryByTract.vue?vue&type=template&id=72dd5d9e&"
import script from "./JournalEntryByTract.vue?vue&type=script&lang=js&"
export * from "./JournalEntryByTract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports